import { render, staticRenderFns } from "./_CompletionBasic.vue?vue&type=template&id=45b567fb&scoped=true&"
import script from "./_CompletionBasic.vue?vue&type=script&lang=js&"
export * from "./_CompletionBasic.vue?vue&type=script&lang=js&"
import style0 from "./_CompletionBasic.vue?vue&type=style&index=0&id=45b567fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b567fb",
  null
  
)

export default component.exports